import * as React from "react";

import Sourcecode from "../../components/Sourcecode";

const SourcecodeListPage: React.FC = () => <Sourcecode />;

export default SourcecodeListPage;
